import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Button,
  List,
  ListItem,
  ListItemText
} from '@mui/material';

const ExcelBlockSelectorDialog = ({
  open,
  onClose,
  excelSheetsData,
  selectedSheetName,
  setSelectedSheetName,
  excelBloques,
  excelRawData,
  onProcesarBloque
}) => {
  const handleExtractManual = () => {
    const inicioStr = document.getElementById('excel-rango-inicio').value;
    const finStr = document.getElementById('excel-rango-fin').value;
    if (!inicioStr || !finStr) {
      alert('Debes indicar ambos márgenes (fila inicial y final) si deseas usar el modo manual.');
      return;
    }
    const rInicio = parseInt(inicioStr) - 1; // Array base 0
    const rFin = parseInt(finStr) - 1;

    // Fake block representation for compatibility
    const manualBlock = {
      id: 'MANUAL',
      filaInicioDatos: rInicio,
      filaFinDatos: rFin
    };
    onProcesarBloque(excelRawData, manualBlock);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle>Extraer Datos de Excel</DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ mb: 3 }}>
          Se ha leído exitosamente el libro de Excel. Por favor, asegúrate de seleccionar la pestaña correcta,
          y luego elige una tabla detectada automáticamente o indica tu rango manual.
        </Typography>

        <Box sx={{ mb: 4 }}>
          <FormControl fullWidth size="small">
            <InputLabel id="sheet-selector-label">Selecciona la Hoja (Pestaña) del Excel</InputLabel>
            <Select
              labelId="sheet-selector-label"
              value={selectedSheetName}
              label="Selecciona la Hoja (Pestaña) del Excel"
              onChange={(e) => setSelectedSheetName(e.target.value)}
            >
              {excelSheetsData.map(sheet => (
                <MenuItem key={sheet.sheetName} value={sheet.sheetName}>
                  Hoja: "{sheet.sheetName}" ({sheet.bloquesEncontrados.length} tablas autodetectadas)
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>

        <Box sx={{ mb: 4, p: 2, border: '1px solid #2196f3', borderRadius: 1, backgroundColor: '#e3f2fd' }}>
          <Typography variant="subtitle2" sx={{ mb: 1, color: '#1565c0' }}>
            Opción A) Modo Extracción Manual:
          </Typography>
          <Box display="flex" alignItems="center" gap={2}>
            <TextField
              label="Fila de Inicio (Ej. 3)"
              size="small"
              type="number"
              id="excel-rango-inicio"
              defaultValue={3}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleExtractManual();
                }
              }}
            />
            <TextField
              label="Fila Final (Ej. 15)"
              size="small"
              type="number"
              id="excel-rango-fin"
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleExtractManual();
                }
              }}
            />
            <Button
              variant="contained"
              color="primary"
              onClick={handleExtractManual}
            >
              Extraer Rango Manual
            </Button>
          </Box>
        </Box>

        <Typography variant="subtitle2" sx={{ mb: 1, color: '#666' }}>
          Opción B) Selecciona un bloque Auto-Detectado de la pestaña actual:
        </Typography>

        <List>
          {excelBloques.length > 0 ? (
            excelBloques.map((bloque) => (
              <ListItem
                key={bloque.id}
                onClick={() => onProcesarBloque(excelRawData, bloque)}
                sx={{
                  border: '1px solid #ddd',
                  borderRadius: 1,
                  mb: 1,
                  backgroundColor: '#f9f9f9',
                  cursor: 'pointer',
                  '&:hover': { backgroundColor: '#e0e0e0' }
                }}
              >
                <ListItemText
                  primary={`Tabla Automática N° ${bloque.id} (Arranca en fila ${bloque.filaEncabezado + 1})`}
                  secondary={`Contiene aproximadamente ${bloque.registrosEstimados} registros validos.`}
                />
              </ListItem>
            ))
          ) : (
            <Typography variant="body2" color="textSecondary" sx={{ p: 2, textAlign: 'center' }}>
              No se detectaron tablas completas automáticamente en esta hoja.
            </Typography>
          )}
        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="inherit">
          Cancelar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ExcelBlockSelectorDialog;
